// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nq-0";